!function ($, global) {
    'use strict';

    var $document = $(global.document);

    var NAME = 'hover-entry-slider';
    var DATA_API = '[data-' + NAME + ']';
    var DATA_NAME = $.camelCase(NAME);

    var ENTRY_NAME = 'entry-id';
    var ENTRY_SELECTOR = '[data-' + ENTRY_NAME + ']';
    var ENTRY_DATA_NAME = $.camelCase(ENTRY_NAME);

    var SLICK_GET = 'getSlick';
    var SLICK_INDEX = 'slickIndex';

    var CLASS_FIXED = 'hover-entry-slider-fixed';

    var MODAL_SELECTOR = '.modal';

    var init = function () {
        var $slider = $(this);
        var slick = $slider.slick(SLICK_GET);
        var menuId = $slider.data(DATA_NAME);
        var current = 0;

        var removes = Array(slick.$slides.length);

        var onBeforeChange = function (event, slick, currentSlide, nextSlide) {
            if (currentSlide && nextSlide) {
                var $item = $(slick.$slides[currentSlide]);

                $item.addClass(CLASS_FIXED);

                if(removes[currentSlide]) {
                    global.clearTimeout(removes[currentSlide]);
                }

                removes[currentSlide] = global.setTimeout(function() {
                    $item.removeClass(CLASS_FIXED);
                }, 500);

            }
        };

        var select = function () {
            var entryId = $(this).data(ENTRY_DATA_NAME);

            current = $('[data-entry-item-id="' + entryId + '"]', $slider).data(SLICK_INDEX);

            slick.goTo(current);
        };

        var deselect = function () {
            current = 0;

            slick.goTo(current);
        };

        $slider.on('beforeChange', onBeforeChange); //.on('afterChange', onAfterChange);

        $('#' + menuId)
            .on('mouseenter focus', ENTRY_SELECTOR, select)
            .on('blur', ENTRY_SELECTOR, deselect)
            .on('mouseleave', deselect)
            .parents(MODAL_SELECTOR)
            .on('show.bs.modal shown.bs.modal', $.proxy(slick.reinit, slick));
    };

    $(DATA_API)
        .on("init reInit breakpoint afterChange", function () {
            $document.trigger('checkAll');
        })
        .slick({
            arrows: false,
            dots: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            fade: true,
            waitForAnimate: false,
            slidesToShow: 1,
            cssEase: 'ease-in-out',
            speed: 300
        })
        .each(init);

}(jQuery, window);
